import { useTranslation } from 'react-i18next';

import type { BookingEventWaveDetail } from '@/types';

import { Badge } from '@/components/ui/badge';

import { cn } from '@/lib/utils';

import { bookingTimeRange } from '@/helpers';

export const ALL_WAVES = null;

type WavePickerProps = {
  waves: BookingEventWaveDetail[];
  selectedWaveId: number | null;
  onWaveSelect: (waveId: number | null) => void;
};

export const WavePicker = (props: WavePickerProps) => {
  const { waves, selectedWaveId, onWaveSelect } = props;
  const { t } = useTranslation();

  return (
    <div className="grid gap-2">
      <p className="text-sm font-medium">{t('Waves')}</p>

      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => onWaveSelect(ALL_WAVES)}
          className={cn(
            'rounded-md border px-3 py-2 text-left text-sm',
            selectedWaveId === ALL_WAVES && 'border-primary bg-muted',
          )}
        >
          {t('All waves')}
        </button>

        {waves.map((wave) => (
          <button
            key={wave.id}
            type="button"
            onClick={() => onWaveSelect(wave.id)}
            className={cn(
              'grid gap-0.5 rounded-md border px-3 py-2 text-left text-sm',
              selectedWaveId === wave.id && 'border-primary bg-muted',
            )}
          >
            <span className="flex items-center gap-2 font-medium">
              {wave.name}
              <Badge variant="secondary">
                {`${wave.taken_spots}/${wave.capacity}`}
              </Badge>
            </span>
            <span className="text-muted-foreground text-xs">
              {bookingTimeRange(wave.starts_at, wave.ends_at)}
              {` · ${wave.service.name}`}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};
